import { Component, Input, NgZone, OnInit, ViewChild } from "@angular/core";
import { IonContent, IonInfiniteScroll, ModalController } from "@ionic/angular";

@Component({
    selector: "app-search-location",
    templateUrl: "./search-location.page.html",
    styleUrls: ["./search-location.page.scss"],
})
export class SearchLocationPage implements OnInit {
    @Input() list: any;

    @ViewChild("searchBar") searchBar: any;
    @ViewChild("infiniteScroll") infiniteScroll: IonInfiniteScroll;
    @ViewChild("content") content: IonContent;

    searchTerm = "";
    showchecklist: any = 50;
    filteredLocationArray: any = [];
    usersLocationArray: any = [];

    constructor(
        public modalController: ModalController,
        private ngZone: NgZone
    ) {}

    search(query) {
        if (!query) {
            this.content.scrollToTop();
            this.usersLocationArray = this.list.slice(0, this.showchecklist);
        } else {
            this.filteredLocationArray = this.list.filter((location) => {
                return (
                    location.locationName
                        .toLowerCase()
                        .indexOf(query.toLowerCase()) > -1
                );
            });
            this.usersLocationArray = this.filteredLocationArray.slice(
                0,
                this.showchecklist
            );
        }

        if (this.usersLocationArray.length < this.showchecklist) {
            this.infiniteScroll.disabled = true;
        } else {
            this.infiniteScroll.disabled = false;
        }
    }

    loadData(event) {
        if (
            this.usersLocationArray.length === 0 ||
            this.usersLocationArray.length < this.showchecklist
        ) {
            event.target.complete();
            event.target.disabled = true;
            return;
        }

        setTimeout(() => {
            if (this.searchTerm) {
                if (
                    this.filteredLocationArray.length >
                    this.usersLocationArray.length
                ) {
                    this.usersLocationArray = this.usersLocationArray.concat(
                        this.filteredLocationArray.slice(
                            this.usersLocationArray.length,
                            this.showchecklist + this.usersLocationArray.length
                        )
                    );
                }

                if (
                    this.filteredLocationArray.length ===
                    this.usersLocationArray.length
                ) {
                    this.ngZone.run(() => {
                        event.target.complete();
                        event.target.disabled = true;
                    });
                }
            } else {
                if (this.list.length > this.usersLocationArray.length) {
                    this.usersLocationArray = this.usersLocationArray.concat(
                        this.list.slice(
                            this.usersLocationArray.length,
                            this.showchecklist + this.usersLocationArray.length
                        )
                    );
                }

                if (this.list.length === this.usersLocationArray.length) {
                    this.ngZone.run(() => {
                        event.target.complete();
                        event.target.disabled = true;
                    });
                    return;
                }
            }

            this.ngZone.run(() => {
                event.target.complete();
            });
        }, 500);
    }

    ngOnInit() {
        this.usersLocationArray = this.list.slice(0, this.showchecklist);

        setTimeout(() => {
            if (this.searchBar) {
                if (this.searchBar.setFocus) {
                    this.searchBar.setFocus();
                } else {
                    this.searchBar.nativeElement.setFocus();
                }
            }
            if (this.usersLocationArray.length < this.showchecklist) {
                this.infiniteScroll.disabled = true;
            } else {
                this.infiniteScroll.disabled = false;
            }
        }, 1000);
    }

    ionViewDidLoad() {}

    onDismiss = (location) => {
        this.modalController.dismiss(location);
    };
}
